<template>
    <div>
        <StreamBarcodeReader
            id="stream"
            v-if="cameraStarted"
            @decode="onDecode" 
            @loaded="onLoaded">                                                                  
        </StreamBarcodeReader>
    </div>
</template>

<script>
    import * as VuetifyComponents from "vuetify/lib/components";
    import { StreamBarcodeReader } from "vue-barcode-reader";

	export default {
		name: "ActionDialog",

		components: {
            ...VuetifyComponents,
			StreamBarcodeReader
		},

        props: [ 
            "openCamera",
        ],

		data() {
			return {
                cameraStarted: false,
                barcodeData: null	
			};
		},

        watch: {
            openCamera(params){
                this.cameraStarted = params
            },
        },

		methods: {
            startCamera() {
    			try {
      				this.cameraStarted = !this.cameraStarted;
    			} catch (error) {
      				console.log('ERROR>>>>>',error)
    			}
    		},
  			onDecode(decodedValue) {
    			// console.log('Código de barras decodificado:', decodedValue);
    			this.barcodeData = decodedValue;
                
				// console.log('BARCODE',this.barcodeData)
                this.$emit("barcode", this.barcodeData);
  			},
		},
	};
</script>

<style>
    #barcodeVideo{
        width: 100%;
        object-fit: cover;
        height: 200px;
    }
    #stream {
        width: 100%;
        height: 203px;
        margin-left: auto;
        margin-right: auto;
    }
</style>